import { type FC, useLayoutEffect, useState } from "react"

import { query } from "~/utilities/trpc"

import ReactionsModal from "./ReactionsModal"

type Props = { commentId: number | null; onClose(): void }
const CommentReactions: FC<Props> = ({ commentId, onClose }) => {
	const [lastCommentId, setLastCommentId] = useState<number | null>(null)

	const { data: reactions, error } = query.community.listCommentReactions.useQuery(lastCommentId!, {
		enabled: lastCommentId !== null,
	})

	useLayoutEffect(() => {
		if (commentId !== null) {
			setLastCommentId(commentId)
		}
	}, [commentId])

	return (
		<ReactionsModal reactions={reactions} hasError={error !== null} isOpen={commentId !== null} onClose={onClose} />
	)
}

export default CommentReactions
